import { check } from '@/api'
import { checkMobile } from '@/utils'
import { Button, Form, Input, Toast } from 'antd-mobile'
import { useNavigate } from 'react-router-dom'
// import { useState } from 'react'

function Sign() {
  const navigate = useNavigate()

  const handleCheck = async (values: any) => {
    try {
      const data = await check(values)
      if (data) {
        navigate(`/checksuccess?phone=${values.phone}`)
      }
    } catch (err: any) {
      Toast.show({ content: err })
    }
  }

  return (
    <div className='pb-6'>
      <h3 className='text-center text-2xl mt-4 mb-8 font-bold'>签到核验</h3>
      <Form
        // layout="horizontal"
        onFinish={handleCheck}
        footer={
          <Button block type='submit' color='primary' size='large'>
            核验
          </Button>
        }
      >
        <Form.Item
          name='phone'
          label='联系电话'
          rules={[{ required: true, validator: checkMobile }]}
        >
          <Input placeholder='请输入联系电话' />
        </Form.Item>
      </Form>
    </div>
  )
}

export default Sign
